import { renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    "data-testid": "studio-badge",
    class: _normalizeClass(["tw-inline-flex tw-h-fit tw-w-fit tw-items-center tw-truncate tw-rounded-full tw-px-2.5 tw-text-center tw-text-2xs tw-font-medium", {
      'tw-bg-indigo-100 tw-text-indigo-800': _ctx.variation === 'default',
      'tw-bg-sky-50 tw-text-sky-600': _ctx.variation === 'sky',
      'tw-bg-gray-100 tw-text-gray-800': _ctx.variation === 'gray',
      'tw-bg-orange-50 tw-text-deep-orange-600': _ctx.variation === 'orange',
      'tw-bg-rose-100 tw-text-rose-500': _ctx.variation === 'red',
      'tw-bg-green-100 tw-text-green-800': _ctx.variation === 'green'
    }])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}